
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edoEHFCHM6rreWJzvalkyQh6KIjEf03E_hYt4CRWyWBzkIMeta } from "/var/www/2025-05-20_17_35/pages/edo.vue?macro=true";
import { default as helpdGumcKtwhKee0yUMMOPnBq_45SpAubdGqSaPMGYCCJBEgMeta } from "/var/www/2025-05-20_17_35/pages/help.vue?macro=true";
import { default as cargoHdpuHXWwWUYb7xFsnH3XYvRy9_45kGDN9KtSc0av5mII8Meta } from "/var/www/2025-05-20_17_35/pages/cargo.vue?macro=true";
import { default as china2B3PhumWxz_3INGzC0afpOS7OJr7GiQMfILOI_457aMb0Meta } from "/var/www/2025-05-20_17_35/pages/china.vue?macro=true";
import { default as index0i6mFzoWzkno_45A5LDDDAa9jdsjm0zkgbR_45PWk7WPaF4Meta } from "/var/www/2025-05-20_17_35/pages/index.vue?macro=true";
import { default as _91slug_936LGbEJ9X8zR6Qvhkrmav6wKcFwSlzZg8LaoDZbtJdpEMeta } from "/var/www/2025-05-20_17_35/pages/[slug].vue?macro=true";
import { default as belarusvRAlj8QWIqz2UKVO3JDglLE0QNGYLKnR2cBxAxCuMoMMeta } from "/var/www/2025-05-20_17_35/pages/belarus.vue?macro=true";
import { default as bonuses4WriXssXON0ob2zv6uo_x3rrqogwoEBcjGGLys4SNx0Meta } from "/var/www/2025-05-20_17_35/pages/bonuses.vue?macro=true";
import { default as apiOtr5AXeaYBQTN7lpJMRG3yhR3yTxaE6NrEfc5g6zEkAMeta } from "/var/www/2025-05-20_17_35/pages/dev/api.vue?macro=true";
import { default as cmsROoT5aW9XdIVpswatgdb7Robxf5aI8R_hRTQf7FAGaEMeta } from "/var/www/2025-05-20_17_35/pages/dev/cms.vue?macro=true";
import { default as konkursWr5FPIzZnRuY2YRbegQaauH8tQblsnmWLYyD5uDZyXEMeta } from "/var/www/2025-05-20_17_35/pages/konkurs.vue?macro=true";
import { default as success6EeSJVnzgVBbwj4DXrwTNZTBZRIbcs7TpVGcYC8Pr50Meta } from "/var/www/2025-05-20_17_35/pages/success.vue?macro=true";
import { default as tariffsT9bTzXtUv6j8L53ydOuMTuLuI2pXg_R62vUh5dar80YMeta } from "/var/www/2025-05-20_17_35/pages/tariffs.vue?macro=true";
import { default as vacancydLRLj0Y7iauI4XdKuTv5vW7leMgmXPLU4tIYVM8A6egMeta } from "/var/www/2025-05-20_17_35/pages/vacancy.vue?macro=true";
import { default as contacts_45n5io78Cc1xmCErcF888M4EClSJqycOsoSTWmRaild8Meta } from "/var/www/2025-05-20_17_35/pages/contacts.vue?macro=true";
import { default as giveaway_45JY4ztOyu1qCuo6jeGH_45QP6Mmf1U4xSeke0Y2Bqkf7MMeta } from "/var/www/2025-05-20_17_35/pages/giveaway.vue?macro=true";
import { default as guide_45lk5GxZfguxPqJs1MNNTkUGz7qnDmwUozQJpEgDLmepI38Meta } from "/var/www/2025-05-20_17_35/pages/guide-lk.vue?macro=true";
import { default as servicesKNbasWKdq0zz3wAlkk1S7K4xXt1GolE_jSaQbYV6DLQMeta } from "/var/www/2025-05-20_17_35/pages/services.vue?macro=true";
import { default as telegramPpR2oSl49x6uiN3poZAeZlYPeJEDWRa79KeeAESoaLwMeta } from "/var/www/2025-05-20_17_35/pages/telegram.vue?macro=true";
import { default as documentsl2taJyId5EdrsBbH2kNkGRhlwPjvLp52NTAKRhgmYBAMeta } from "/var/www/2025-05-20_17_35/pages/documents.vue?macro=true";
import { default as franchisexFi0fIpgw_7j4CivXm3qwCYosuN0gXfCe8LJiJUAHz8Meta } from "/var/www/2025-05-20_17_35/pages/franchise.vue?macro=true";
import { default as insuranceoL5XT_45A_lE6facguI5fH5jYwoBP74Ci1qnVpE8r79fwMeta } from "/var/www/2025-05-20_17_35/pages/insurance.vue?macro=true";
import { default as kirghiziaNCzthIIMgf0gR_HVjIYT2EnXGGKsJt36BcyWtMVxzTUMeta } from "/var/www/2025-05-20_17_35/pages/kirghizia.vue?macro=true";
import { default as mapSchemeEA_3JWKjKxTa8LOFjZnKIWMX3l5qHFJMi6lsSekTSWcMeta } from "/var/www/2025-05-20_17_35/pages/mapScheme.vue?macro=true";
import { default as _91id_93vI2Ec1PhrYd0n6K84EuqUMIoBPh44Fu2e4pTsm4RjXsMeta } from "/var/www/2025-05-20_17_35/pages/news/[id].vue?macro=true";
import { default as return_45sdQ3pGTaa2zforIbXd0x7MdjotGFvsMgJdFYWoBenDvbYMeta } from "/var/www/2025-05-20_17_35/pages/return-sd.vue?macro=true";
import { default as smsClientwlS8Lvvy4MsSM05ocdzOPxEa6HBDQxGK0Tlmmn7YstkMeta } from "/var/www/2025-05-20_17_35/pages/smsClient.vue?macro=true";
import { default as terminalsUGkPN34LaNar7f5s1wBxiitvfP_IJ5mVoatJgJBQsIwMeta } from "/var/www/2025-05-20_17_35/pages/terminals.vue?macro=true";
import { default as iframeB0t9ux8xWsLnm0OttJCqJQ1HzKIxtTR4HycUcfve3fsMeta } from "/var/www/2025-05-20_17_35/pages/dev/iframe.vue?macro=true";
import { default as directionsBJSIi_tMqxFnU31Cu3RkJNP0TEHqZVVvDiSD5QkKJeIMeta } from "/var/www/2025-05-20_17_35/pages/directions.vue?macro=true";
import { default as kazakhstan_2Z5qa1G7bIs7L0IYpthbYJJdU8CuBknTGzM2I0UEywMeta } from "/var/www/2025-05-20_17_35/pages/kazakhstan.vue?macro=true";
import { default as indexOAWVrcrrb_45ws4fzeMbbetKH0tBYmtcF8Xulsk0UOc_45YMeta } from "/var/www/2025-05-20_17_35/pages/news/index.vue?macro=true";
import { default as svgkSdTTuVW3Ir05oigdZKrBV0Ujd7pwAL0cXkYpn4Qa58Meta } from "/var/www/2025-05-20_17_35/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failce8aLY0XJRc_bdYHP7z0EeSIl8RSH11d3UsLha1o3qgMeta } from "/var/www/2025-05-20_17_35/pages/vzpay-fail.vue?macro=true";
import { default as constructorvImfwfTuXzaJ8xOA1ZWd3V3fnI0xHugNTrS1mzWzxLsMeta } from "/var/www/2025-05-20_17_35/pages/constructor.vue?macro=true";
import { default as indexu86GkC90PMS8FdhH_eeiOlDCNZkbcuF2gacZ4yWUhPEMeta } from "/var/www/2025-05-20_17_35/pages/gifts/index.vue?macro=true";
import { default as informationFrHQFeTnM3uKSH3IyZoNt5CV_AWHhiJ2OEPfwDKt32MMeta } from "/var/www/2025-05-20_17_35/pages/information.vue?macro=true";
import { default as lightSyp_45UOSxBn_PTWwSRzPDthcRUvEh83Eoz7wQjClF4kkMeta } from "/var/www/2025-05-20_17_35/pages/order/light.vue?macro=true";
import { default as claim_45filingR55pysm5JXmd_45COBFq53enJVKzFyGcN3oHcDNCw_45mgIMeta } from "/var/www/2025-05-20_17_35/pages/claim-filing.vue?macro=true";
import { default as _91type_93V7BCmxORdMCsUMLC5JjuCai_45YFLmEHc2LdKTy9K5sFQMeta } from "/var/www/2025-05-20_17_35/pages/gifts/[type].vue?macro=true";
import { default as marketplacesISqViQh1CocHL33vM_24UX_9FCa_45sAH2Y_E819NyUAMMeta } from "/var/www/2025-05-20_17_35/pages/marketplaces.vue?macro=true";
import { default as networkshops8hwTro0joom63CyaIjFXFR_45fVOHqKxom_bhEH1Ttsv4Meta } from "/var/www/2025-05-20_17_35/pages/networkshops.vue?macro=true";
import { default as online_45storeaDAk_452fA12cRJrghkIY__45_45x4guBrbWiAjzLd_BGdO1IMeta } from "/var/www/2025-05-20_17_35/pages/online-store.vue?macro=true";
import { default as managerHeH20h1rreQZCasoE67aJlwbTnc2Pq_45_qESDA8ALWQMeta } from "/var/www/2025-05-20_17_35/pages/order/manage.vue?macro=true";
import { default as registrationHDf1bUsSAq8koolZlwZtiNDV0sH0ZTedSe9PpqlTCscMeta } from "/var/www/2025-05-20_17_35/pages/registration.vue?macro=true";
import { default as run_45scheduleAHZXB5Ps_Mh_bNvDRjEInwQaHHxM8nnR8XFEFUm6T1YMeta } from "/var/www/2025-05-20_17_35/pages/run-schedule.vue?macro=true";
import { default as safe_45custodybXfv3tH8YkmAZVn3UVXJiChbVJunSvBVX58ta03ZZhAMeta } from "/var/www/2025-05-20_17_35/pages/safe-custody.vue?macro=true";
import { default as imageGseUGKNHPJ00xYyiEEWezhaYDlcJc9aYdXujrl02CB4Meta } from "/var/www/2025-05-20_17_35/pages/ui-kit/image.vue?macro=true";
import { default as indexvsYghIL_frVilZoXIcK6dYGnPWAGC1vbKQtVeYePLaAMeta } from "/var/www/2025-05-20_17_35/pages/ui-kit/index.vue?macro=true";
import { default as bagVVJScupH9THzyJgiJuyCpspfn0n7vFpqJadUpEyvWLMMeta } from "/var/www/2025-05-20_17_35/pages/wrapping/bag.vue?macro=true";
import { default as boxIHBaJP93OJCKwkjWwH4Yti5GwNq5Fo4U93I4ULn6eTwMeta } from "/var/www/2025-05-20_17_35/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadinguhgEd6FS3JCwjTLNaPBulnw_4MI65Mj5_45EFTY8itwqEMeta } from "/var/www/2025-05-20_17_35/pages/cargo-loading.vue?macro=true";
import { default as happybirthday48eSXlUOGzCa5DkhX7SvXrtt4UDAPpLDUgO7Otd9vi4Meta } from "/var/www/2025-05-20_17_35/pages/happybirthday.vue?macro=true";
import { default as manageDUIzFqX_45h5gZLFvzR8MlB_Y9YpzkNhIQpITOIdXdCP0Meta } from "/var/www/2025-05-20_17_35/pages/iframe/manage.vue?macro=true";
import { default as authI5MWK3smQ9aS1YnaNanaDYlH2i7ZqEXnA9QDloN2SC4Meta } from "/var/www/2025-05-20_17_35/pages/personal/auth.vue?macro=true";
import { default as publicpoJkBKL2_EZ6ZoeimL81XnlqHZ8YHtsPVmtR4LfzhNsMeta } from "/var/www/2025-05-20_17_35/pages/ui-kit/public.vue?macro=true";
import { default as already_45answeryipsFSm_LRpdF9tV9hWZs_L68YG_A_456sT0zHS8u_UggMeta } from "/var/www/2025-05-20_17_35/pages/already-answer.vue?macro=true";
import { default as tariffs58wwqiIlnxm_VPqz9J43Kn024mAWQed_VaXbZgtGe0UMeta } from "/var/www/2025-05-20_17_35/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93bWuuDP9K_1GJxYyz1wuSGuWsDYnqn7ha8MPH54VFBrwMeta } from "/var/www/2025-05-20_17_35/pages/order/pay/[id].vue?macro=true";
import { default as index9uEsutnQotmswFTTJtoxX9JcGciNa6e6EAhSi4k3x14Meta } from "/var/www/2025-05-20_17_35/pages/personal/index.vue?macro=true";
import { default as privacy_45policyb1gQotifP7UqtNkW7vUm5cn2zPIZArKtPuNHCq9k2R0Meta } from "/var/www/2025-05-20_17_35/pages/privacy-policy.vue?macro=true";
import { default as _91hash_930bzGC8kJoedWs1lvzz8Pt3L3KI9ZWan8pdzMCjDjTZgMeta } from "/var/www/2025-05-20_17_35/pages/welcome/[hash].vue?macro=true";
import { default as indexA9JGVobHqJ7c9sd_UDwuEK_453wBQexBwvx396Y7AZNo4Meta } from "/var/www/2025-05-20_17_35/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiat62GtY0vSUw8qKobSEsUab0bBDdk_45DLwUuPGwyWfCiAMeta } from "/var/www/2025-05-20_17_35/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodsqAUJ3ryF54nbhwaQCOmHcH7VlB79MMFDhIcmMGlfIXYMeta } from "/var/www/2025-05-20_17_35/pages/payment-methods.vue?macro=true";
import { default as qr_45info9l0ufZigntq_45FM4mPBpH1XJoT7J3a_45T7fUykD61U4TwMeta } from "/var/www/2025-05-20_17_35/pages/payment/qr-info.vue?macro=true";
import { default as successglRwOMvzcTu_45xUeO3cPugQv76ZYZVp_HonwVmRfhZU4Meta } from "/var/www/2025-05-20_17_35/pages/payment/success.vue?macro=true";
import { default as importVYFQEHkE8Xo4EYg_3D56_45cVrh29ykh42OZjaiqIb50kMeta } from "/var/www/2025-05-20_17_35/pages/personal/import.vue?macro=true";
import { default as logoutf3wOsgy89s4VaXlkHYIEA7o8GlHPGb6D8hbnueBSi0oMeta } from "/var/www/2025-05-20_17_35/pages/personal/logout.vue?macro=true";
import { default as address_45deliveryELmg52QT1PJjiJB9Wk5KNvQwPIJ2MT76aI4JecJ0gdgMeta } from "/var/www/2025-05-20_17_35/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45delivery_KhjzYBEc51YXJAX2Cc_rBDRIR5xqzSY7BdIpD3cDDAMeta } from "/var/www/2025-05-20_17_35/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear2024B88pBi3Oo_rYSV5JVhYEi67Kg54fHbyil0XfQLw1Ko4Meta } from "/var/www/2025-05-20_17_35/pages/happynewyear2024.vue?macro=true";
import { default as ozonLUyMe77Cd1ClUEZ3SSTSIYTdAlDpbJL3vlWjOUZx_45poMeta } from "/var/www/2025-05-20_17_35/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failm88os_45khErvdndurmzO_456_kpBTmW4QHSvIYtRtyVqYQMeta } from "/var/www/2025-05-20_17_35/pages/payment/pay-fail.vue?macro=true";
import { default as account7Xyo55_T4yNRrlHRtXVnZubwmAcOcd_OjXJwoOE2iqcMeta } from "/var/www/2025-05-20_17_35/pages/personal/account.vue?macro=true";
import { default as prohibited_45goods5zbYtuEdJJodzWrGjAdJJgaFgsEyGZ3wEdmKud73y1sMeta } from "/var/www/2025-05-20_17_35/pages/prohibited-goods.vue?macro=true";
import { default as directionYYSFekpSg9hGqmlA_ybAyWLknm_fdkp_45mEOc9pH5AMIMeta } from "/var/www/2025-05-20_17_35/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupijF8pDC3fX5ae7mCRj_45InjGJdqAGM_sw2zHpVXCqNCUMeta } from "/var/www/2025-05-20_17_35/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargo09fcryof2jyNwGWo4cIDoPiP7aS1M6HNdguo8WATmaYMeta } from "/var/www/2025-05-20_17_35/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorj9lKgW0S7494XzrMtDLTTAqnjNYrGx_45pDi2YuKLhaT4Meta } from "/var/www/2025-05-20_17_35/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonuses5ctKiv8km7eaZ0SabL_U6nXJAULHT4VZM_45gRs0HmlW0Meta } from "/var/www/2025-05-20_17_35/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93k96aX9MdJoZzGuYfmg25aulbLx_459suJlQX65Vds1vSAMeta } from "/var/www/2025-05-20_17_35/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infouBZR7wR9VmiyhG3C_45aN10aLYUvn2plw8qEmOKMU1JjwMeta } from "/var/www/2025-05-20_17_35/pages/payment/card-info.vue?macro=true";
import { default as discounta_45nQhcdoK0vZrorB_45tzRwhpjelvWvgG2nbrx4PDvhNIMeta } from "/var/www/2025-05-20_17_35/pages/personal/discount.vue?macro=true";
import { default as hard_45boxeR2Y4Ug8JyuV0QSPI13wTXm6SkY4W0ozAnPyxycg9wcMeta } from "/var/www/2025-05-20_17_35/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptH9RYgwOrVjbWP_45Kx6Z458i4CB7iqmnE5i_1WPqGNPY0Meta } from "/var/www/2025-05-20_17_35/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917o1NAe671uC1EEbLPo3mLPlDaA0eIhKLndXeuOflkKLAMeta } from "/var/www/2025-05-20_17_35/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45application1jwm81gBfz9dcUzs9McoinE101I4VCL5wHaqWEuHOmsMeta } from "/var/www/2025-05-20_17_35/pages/mobile-application.vue?macro=true";
import { default as index6zWSJz3NhCpUOYny0_45e9UWCacUu2WeQzS_45F9GtyKA60Meta } from "/var/www/2025-05-20_17_35/pages/order/create/index.vue?macro=true";
import { default as boatfHK_45XuWeVnYDGKTycqz0DNK438F0R7bzfiFQ946nk58Meta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/boat.vue?macro=true";
import { default as sofa36MtntmEw8D8f5Q87iK691KbwqLhV4y3Bd12BzQtVm4Meta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/sofa.vue?macro=true";
import { default as cardboard_45Rbq5gnD7Mb7bRa2pHWFm0si87wDayURdsrXiNfdz7EMeta } from "/var/www/2025-05-20_17_35/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesMOGMXSr3Hq0TotF758FyHiE5A3KmvkMD0kyYsRa8rUwMeta } from "/var/www/2025-05-20_17_35/pages/personal/promocodes.vue?macro=true";
import { default as bench9Kpd89qRut1q96H_45pBgNdDK2ziDo_45DZ4dfdq9ODDQAkMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/bench.vue?macro=true";
import { default as booksUXX1vcCbqAR5cl0zKBfVakOsrlrpWxFragp7MDbfvNYMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/books.vue?macro=true";
import { default as cable1R7_7u_fLbRBqkwL10FQqq6gaugaLHRvgO_b1ZMxi_4Meta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/cable.vue?macro=true";
import { default as chairNBFTuZUKmkDbWMUgJ0aWBjp36RNwHmVgI2zXKF7nmrMMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsinmq4z1hL4jg6cV5fc6_45YQ4w9_45VZik_45TpbXuUpw39NMMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/goods.vue?macro=true";
import { default as indexhh843yV_45K3RYHkyCjNvTKE1QNeSyVgW9J7LZiIJPOuUMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/index.vue?macro=true";
import { default as metalokf7YcYIXPgbX9Jtv0ah8gZESy0P9zfN_BgkfDNkypQMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/metal.vue?macro=true";
import { default as pianoniDmDirjF74Be0WbXMhNQxq_GrX77FMY3AWfjAjYA0wMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/piano.vue?macro=true";
import { default as pipeseVQ33YM_bJwOveEZJvP6K8kctMOez4JVci6VD53sn_sMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/pipes.vue?macro=true";
import { default as tools7nKHDoPQxqFsA4j2q7xRysF_hHNK_oh2YMOVDTm2dXAMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxeZiC5UAoku1BgASW5TPtdI8kKAu2qKRfYMjrmMQaaQEMeta } from "/var/www/2025-05-20_17_35/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93vo3H0tkHp5rV4PPaxiz8O6MWQ_OgvP8cO0vO5yCs5tcMeta } from "/var/www/2025-05-20_17_35/pages/personal/bonus/[tab].vue?macro=true";
import { default as printjK4Ey6ZC_x2oBJVtr04OdRMnUNDleOL8EF6xUVjTKjMMeta } from "/var/www/2025-05-20_17_35/pages/personal/order/print.vue?macro=true";
import { default as dishesvgR12SRt1WpKL0gc7EQjpKsV5C825M2PxSEW7FM7ng0Meta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/dishes.vue?macro=true";
import { default as enginehS3QBBBZdmEKdYyq38RX0YGvmK_H7DAluP36rTspKjcMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberfw3UOWDpAHhh3ssnh4KmEaV4M5EajFkhpGyulSo17ssMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsCHfE_swjF48ffDcNSVWx5fy7vpPhP_45jE9RlorAbIlrQMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmPs8_45Sq8WQaV_ABssKXhztYqjZdINJjoNw3rKPBMETycMeta } from "/var/www/2025-05-20_17_35/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingy4_dCJ89gWCS8mZMbpbjSVJXlsqcqILHDdgo0a1SwLUMeta } from "/var/www/2025-05-20_17_35/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalIR3y_kDrAzF40NaZEFuGMTbk1wk5v4NX7UHY5c3UVLAMeta } from "/var/www/2025-05-20_17_35/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93hAOKnd8xoV5kI0Sn_45Qhx7ntl4sp_45_6DLfXSxJAoXkN4Meta } from "/var/www/2025-05-20_17_35/pages/personal/order/[guid].vue?macro=true";
import { default as createfxXAcz3LtM_455YKdNfwHMwhbZUhHfWxsyfRVLbVcCnQUMeta } from "/var/www/2025-05-20_17_35/pages/personal/order/create.vue?macro=true";
import { default as barrelsX62cykO9u_AECt44OrypQYmDkoSHnremRz6JwxQduI8Meta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesLvgxrbrouO7w2A5gTR4B7TMpNJIu39mV7WFr5L6PjFEMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragileGwdrYLOds8nqiOUqaL44iYdOHMy1GbhToP4GWbjW3qgMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailerVcuBn0rJKBz20mSz3VPzO6hdhiFNm8BnE_45_45Kfc_63X0Meta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packageFVNPPEZegW60XCZOZTqGjeGuMEd7rI9YecyoAlAx13AMeta } from "/var/www/2025-05-20_17_35/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successOts9k4c_i3SGI_trziZk_OZi3DboYg_9cMoPosMarB4Meta } from "/var/www/2025-05-20_17_35/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packagehvNEGteNEi6jorHXZShcSi4Ss0_8dzNxcR7v1ZYmHdUMeta } from "/var/www/2025-05-20_17_35/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriesxAsKFTVrXIKbcUCNQw3q60_SgUSMCi1iWyHSFAoIGUgMeta } from "/var/www/2025-05-20_17_35/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93fH_45p7fI_GxHE1Q3sZiYvUtoYIGHB2SwMWd8miWQXruoMeta } from "/var/www/2025-05-20_17_35/pages/order/administer/[guid].vue?macro=true";
import { default as furnitureC9SWW44FYA_SqBQ37J0_Ioiwz8g0_d54izWstBCDbPgMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversizedjDpKt0nDmbyL7b_45hM06uzZjVD7I2_Ur52oypN_45ZSeaIMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bike0etjEkXnr3cu6_45Vp9qTGwPDVNjaabdB0cUebaWEtqVQMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_938szQvJkLtvDa5zPN0794ZrmCGF_hURw_10KCjCvGwQ4Meta } from "/var/www/2025-05-20_17_35/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93TCTRAPMHjF_vpOy8iz828o29mmircaTCoFuDsuav7zIMeta } from "/var/www/2025-05-20_17_35/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45parts1vWb6Q_45dY5vlrNMXY8cAKOvDmj9MOfUVpirO0jPa5qwMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapersimUWC5EqPvrxlaWmCXoJgjo5_45XzLz6ydR_q21vQZ8_45QMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargocPSFIuV9g_mzFyTAu6CoN_452zZILbGZsGYiZfBN8jk1YMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobilegdWEDWsVHJC40xganW_45uP_Woda4r9EzhffvY6BcA7dgMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as index56NI5vb4yjzBfE_456S4Vi0oEwhhT4S415V22ezJULQIYMeta } from "/var/www/2025-05-20_17_35/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketPie3dADwS6b3ygCPR5TfV2JfiD1lLx_45cOESkNYmDZaoMeta } from "/var/www/2025-05-20_17_35/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatesqpTNjeYgmSEGWxd8HlDrUI64fXSa4BbVXJUnEJyNgGkMeta } from "/var/www/2025-05-20_17_35/pages/personal/orders/templates.vue?macro=true";
import { default as indexmK405FTYcDbwXk0ECLcuwgqJTCAJPaHWW6iY9wLlwpMMeta } from "/var/www/2025-05-20_17_35/pages/personal/contractors/index.vue?macro=true";
import { default as refrigerator1SWK3z3__45aJEIuB_JHchsogE6OJ4wXhZdsJ1bz0dsJoMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93G9RwWRwbNcITWYikuxhDhB4ynoByEIEdykpnVjTD_453oMeta } from "/var/www/2025-05-20_17_35/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexgBxb8eamZM6aZKDL7v9grfcOFW_K82E1l9hiafX6G1QMeta } from "/var/www/2025-05-20_17_35/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93EoBR99nDaO1w2FO9GliQUAZWUXtR9_455uvlgJC_45s1dtwMeta } from "/var/www/2025-05-20_17_35/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsc3JdaEQgJNTSuU8oFRA2e8eZTIjLx675o6Wh1H9pBLQMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as index8hLCc0bz7NIW5LW3arKoTJBRYCou2Itmhrr9RLiD7u8Meta } from "/var/www/2025-05-20_17_35/pages/personal/group-printing/index.vue?macro=true";
import { default as index1ymbGqMkcWfOEKdrzAlrgDz6fqgHU28PAjYsIpHaKW8Meta } from "/var/www/2025-05-20_17_35/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devices1_AHDi1IdN5YBh5uBo1NtA0jzUkfiVTMkiglYEq3nBUMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93k0_45khAFEQoCW5UXRCwHbmGL52_45vIpi6eSRzFcecFHCgMeta } from "/var/www/2025-05-20_17_35/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93Wc7_eG_zHq3D3CFygLIEa5p1LxZBUa5vNBttt8EHljIMeta } from "/var/www/2025-05-20_17_35/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_934DY0IJvMB5QstGYthaf0h_45gSJcsA5s4CycEGxrqvJy8Meta } from "/var/www/2025-05-20_17_35/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipmentxwGYVBbeMTwat_MGTqZoYVVmx7WcMPcu40Vi2Wm5SF0Meta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materials6_CQPD_kJ7FUsX6FXJ_f2GZzcaCTs_30VENKgGDMH6sMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentslkh8RPkG_45JEKWkxetvk1jiWbUDmELSe9rgD0rXrHvREMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipment2hfwq4c1Y8ZSv9QpaZ7suhdL_G184uxWGYgLjUTSEJ4Meta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportation0_WSkBGNS5PY3We9QvBEwf3h5sZ5Bv4JjrkRGxg2Z5gMeta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_9303O98tt2VLwnMKfvVBQWAINZCI4hdYZlCgkizXo7sFUMeta } from "/var/www/2025-05-20_17_35/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationHsuofBLdtK0__45kA5D8zJmj_LBeVl6Y_zZ1XfKfuFeF8Meta } from "/var/www/2025-05-20_17_35/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-05-20_17_35/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-05-20_17_35/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-05-20_17_35/pages/cargo.vue")
  },
  {
    name: "china",
    path: "/china",
    component: () => import("/var/www/2025-05-20_17_35/pages/china.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-05-20_17_35/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_936LGbEJ9X8zR6Qvhkrmav6wKcFwSlzZg8LaoDZbtJdpEMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/[slug].vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-05-20_17_35/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-05-20_17_35/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-05-20_17_35/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-05-20_17_35/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkursWr5FPIzZnRuY2YRbegQaauH8tQblsnmWLYyD5uDZyXEMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-05-20_17_35/pages/success.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-05-20_17_35/pages/tariffs.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-05-20_17_35/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contacts_45n5io78Cc1xmCErcF888M4EClSJqycOsoSTWmRaild8Meta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-05-20_17_35/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-05-20_17_35/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-05-20_17_35/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-05-20_17_35/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-05-20_17_35/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-05-20_17_35/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-05-20_17_35/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-05-20_17_35/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemeEA_3JWKjKxTa8LOFjZnKIWMX3l5qHFJMi6lsSekTSWcMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93vI2Ec1PhrYd0n6K84EuqUMIoBPh44Fu2e4pTsm4RjXsMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-05-20_17_35/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-05-20_17_35/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-05-20_17_35/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-05-20_17_35/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-05-20_17_35/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-05-20_17_35/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexOAWVrcrrb_45ws4fzeMbbetKH0tBYmtcF8Xulsk0UOc_45YMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-05-20_17_35/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-05-20_17_35/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructorvImfwfTuXzaJ8xOA1ZWd3V3fnI0xHugNTrS1mzWzxLsMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexu86GkC90PMS8FdhH_eeiOlDCNZkbcuF2gacZ4yWUhPEMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-05-20_17_35/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-05-20_17_35/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-05-20_17_35/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93V7BCmxORdMCsUMLC5JjuCai_45YFLmEHc2LdKTy9K5sFQMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-05-20_17_35/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-05-20_17_35/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-05-20_17_35/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-05-20_17_35/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-05-20_17_35/pages/registration.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-05-20_17_35/pages/run-schedule.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-05-20_17_35/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-05-20_17_35/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-05-20_17_35/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-05-20_17_35/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-05-20_17_35/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-05-20_17_35/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthday48eSXlUOGzCa5DkhX7SvXrtt4UDAPpLDUgO7Otd9vi4Meta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manageDUIzFqX_45h5gZLFvzR8MlB_Y9YpzkNhIQpITOIdXdCP0Meta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/auth.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-05-20_17_35/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-05-20_17_35/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffs58wwqiIlnxm_VPqz9J43Kn024mAWQed_VaXbZgtGe0UMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-05-20_17_35/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: index9uEsutnQotmswFTTJtoxX9JcGciNa6e6EAhSi4k3x14Meta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-05-20_17_35/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-05-20_17_35/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-05-20_17_35/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-05-20_17_35/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-05-20_17_35/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-05-20_17_35/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-05-20_17_35/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importVYFQEHkE8Xo4EYg_3D56_45cVrh29ykh42OZjaiqIb50kMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutf3wOsgy89s4VaXlkHYIEA7o8GlHPGb6D8hbnueBSi0oMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-05-20_17_35/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-05-20_17_35/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear2024B88pBi3Oo_rYSV5JVhYEi67Kg54fHbyil0XfQLw1Ko4Meta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozonLUyMe77Cd1ClUEZ3SSTSIYTdAlDpbJL3vlWjOUZx_45poMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-05-20_17_35/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: account7Xyo55_T4yNRrlHRtXVnZubwmAcOcd_OjXJwoOE2iqcMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-05-20_17_35/pages/prohibited-goods.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-05-20_17_35/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-05-20_17_35/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-05-20_17_35/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorj9lKgW0S7494XzrMtDLTTAqnjNYrGx_45pDi2YuKLhaT4Meta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-05-20_17_35/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-05-20_17_35/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-05-20_17_35/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discounta_45nQhcdoK0vZrorB_45tzRwhpjelvWvgG2nbrx4PDvhNIMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-05-20_17_35/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-05-20_17_35/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917o1NAe671uC1EEbLPo3mLPlDaA0eIhKLndXeuOflkKLAMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-05-20_17_35/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: index6zWSJz3NhCpUOYny0_45e9UWCacUu2WeQzS_45F9GtyKA60Meta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/order/create/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/sofa.vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-05-20_17_35/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesMOGMXSr3Hq0TotF758FyHiE5A3KmvkMD0kyYsRa8rUwMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-05-20_17_35/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93vo3H0tkHp5rV4PPaxiz8O6MWQ_OgvP8cO0vO5yCs5tcMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printjK4Ey6ZC_x2oBJVtr04OdRMnUNDleOL8EF6xUVjTKjMMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-05-20_17_35/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-05-20_17_35/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-05-20_17_35/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93hAOKnd8xoV5kI0Sn_45Qhx7ntl4sp_45_6DLfXSxJAoXkN4Meta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: createfxXAcz3LtM_455YKdNfwHMwhbZUhHfWxsyfRVLbVcCnQUMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-05-20_17_35/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-05-20_17_35/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-05-20_17_35/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriesxAsKFTVrXIKbcUCNQw3q60_SgUSMCi1iWyHSFAoIGUgMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-05-20_17_35/pages/order/administer/[guid].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-05-20_17_35/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93TCTRAPMHjF_vpOy8iz828o29mmircaTCoFuDsuav7zIMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: index56NI5vb4yjzBfE_456S4Vi0oEwhhT4S415V22ezJULQIYMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketPie3dADwS6b3ygCPR5TfV2JfiD1lLx_45cOESkNYmDZaoMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatesqpTNjeYgmSEGWxd8HlDrUI64fXSa4BbVXJUnEJyNgGkMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexmK405FTYcDbwXk0ECLcuwgqJTCAJPaHWW6iY9wLlwpMMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93G9RwWRwbNcITWYikuxhDhB4ynoByEIEdykpnVjTD_453oMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexgBxb8eamZM6aZKDL7v9grfcOFW_K82E1l9hiafX6G1QMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93EoBR99nDaO1w2FO9GliQUAZWUXtR9_455uvlgJC_45s1dtwMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: index8hLCc0bz7NIW5LW3arKoTJBRYCou2Itmhrr9RLiD7u8Meta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: index1ymbGqMkcWfOEKdrzAlrgDz6fqgHU28PAjYsIpHaKW8Meta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93k0_45khAFEQoCW5UXRCwHbmGL52_45vIpi6eSRzFcecFHCgMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93Wc7_eG_zHq3D3CFygLIEa5p1LxZBUa5vNBttt8EHljIMeta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_934DY0IJvMB5QstGYthaf0h_45gSJcsA5s4CycEGxrqvJy8Meta || {},
    component: () => import("/var/www/2025-05-20_17_35/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-05-20_17_35/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-05-20_17_35/pages/shippingtypes/personalitemstransportation.vue")
  }
]